/* eslint-disable @typescript-eslint/no-explicit-any */
export class TimeSelect {
    static readonly START: string = 'START_TIME';
    static readonly END: string = 'END_TIME';
    static readonly SELECT: string = 'SELECT_TIME';

    static readonly NONE: string = 'NONE';
    static readonly WEEK: string = 'WEEK';
    static readonly TODAY: string = 'TODAY';
    static readonly YESTERDAY: string = 'YESTERDAY';
    static readonly MONTH: string = 'MONTH';
    static readonly FORM: any = [
        {
            type: 'calendar',
            name: TimeSelect.START,
            label: 'Start Date',
            enableTime: true,
            dateFormat: '%Y-%m-%d %H:%i',
            labelWidth: '120',
            position: 'label-left',
            offsetLeft: '12',
        },
        {
            type: 'calendar',
            name: TimeSelect.END,
            label: 'End Date',
            enableTime: true,
            dateFormat: '%Y-%m-%d %H:%i',
            labelWidth: '120',
            position: 'label-left',
            offsetLeft: '12',
        },
        {
            type: 'select',
            name: TimeSelect.SELECT,
            label: 'Time Period',
            labelWidth: '120',
            offsetLeft: '12',
            options: [
                { text: 'Custom', value: TimeSelect.NONE },
                { text: 'Today', value: TimeSelect.TODAY },
                { text: 'Yesterday', value: TimeSelect.YESTERDAY },
                { text: 'This Week', value: TimeSelect.WEEK },
                { text: 'This Month', value: TimeSelect.MONTH },
            ],
        },
    ];

    static readonly SHORT_FORM: any = [
        {
            type: 'calendar',
            name: TimeSelect.START,
            label: 'Start Date',
            enableTime: true,
            dateFormat: '%Y-%m-%d %H:%i',
            labelWidth: '120',
            position: 'label-left',
            offsetLeft: '12',
        },
        {
            type: 'calendar',
            name: TimeSelect.END,
            label: 'End Date',
            enableTime: true,
            dateFormat: '%Y-%m-%d %H:%i',
            labelWidth: '120',
            position: 'label-left',
            offsetLeft: '12',
        },
        {
            type: 'select',
            name: TimeSelect.SELECT,
            label: 'Time Period',
            labelWidth: '120',
            offsetLeft: '12',
            options: [
                { text: 'Custom', value: TimeSelect.NONE },
                { text: 'Today', value: TimeSelect.TODAY },
                { text: 'Yesterday', value: TimeSelect.YESTERDAY },
            ],
        },
    ];

    static readonly SHORT_FORM_NO_PERIOD: any = [
        {
            type: 'calendar',
            name: TimeSelect.START,
            label: 'Start Date',
            enableTime: true,
            dateFormat: '%Y-%m-%d %H:%i',
            labelWidth: '120',
            position: 'label-left',
            offsetLeft: '12',
        },
        {
            type: 'calendar',
            name: TimeSelect.END,
            label: 'End Date',
            enableTime: true,
            dateFormat: '%Y-%m-%d %H:%i',
            labelWidth: '120',
            position: 'label-left',
            offsetLeft: '12',
        },
    ];

    form: dhtmlXForm;

    constructor(form: dhtmlXForm) {
        this.form = form;
    }

    selectRange(value: string) {
        let start = new Date();
        let end = new Date();

        if (value == TimeSelect.TODAY) {
            start = new Date(new Date().setHours(0, 0, 0, 0));
            end = new Date(new Date().setHours(23, 59, 59, 999));
        }
        if (value == TimeSelect.YESTERDAY) {
            const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
            start = new Date(yesterday.setHours(0, 0, 0, 0));
            end = new Date(yesterday.setHours(23, 59, 59, 99));
        }
        if (value == TimeSelect.WEEK) {
            const week = new Date(new Date().setDate(new Date().getDate() - 7));
            start = new Date(week.setHours(0, 0, 0, 0));
            end = new Date(new Date().setHours(23, 59, 59, 999));
        }
        if (value == TimeSelect.MONTH) {
            start = new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(0, 0, 0, 0));
            end = new Date(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).setHours(23, 59, 59, 999));
        }

        this.form.setItemValue(TimeSelect.START, start);
        this.form.setItemValue(TimeSelect.END, end);

        if (value == TimeSelect.NONE) {
            this.form.setItemValue(TimeSelect.START, '');
            this.form.setItemValue(TimeSelect.END, '');
        }

        this.form.setItemValue(TimeSelect.SELECT, value);
    }
}
